import {createElement} from 'rlink-react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import getCurrentRouteState from 'rlink-router/getCurrentRouteState';
import connectToPathForContent from 'rlink-repos/connectToPathForContent';
import RoutingComponent from 'rlink-router/component';

class Main extends RoutingComponent {
  render () {
    return (<div>
      {this.viewContent()}
    </div>
    );
  }
}

export default compose(
  connect(({routing}) => {
    let {view} = getCurrentRouteState(routing);
    return {currentView: view};
  }),
  connectToPathForContent
)(Main);



// WEBPACK FOOTER //
// ./apps/ingame.companyofheroes.com/src/components/Main.jsx